import React from 'react';

// One definition of "how to get your API keys", used by the API Key Guide page
// and the short guide on the Web and Mobile integration pages. Update the
// dashboard steps here and every page follows.

export const DASHBOARD_URL = 'https://app.wayaquick.com';

export const API_KEYS_PATH = ['Settings', 'WayaQuick Settings', 'API Keys'];

// Where merchants find their Merchant ID in the dashboard.
export const MERCHANT_ID_LOCATION = 'at the top left corner of your dashboard';

export const API_KEY_STEPS = [
    <>
        Log in to your merchant dashboard at{' '}
        <a href={DASHBOARD_URL} target="_blank" rel="noreferrer" className="wq-link">
            app.wayaquick.com
        </a>
        .
    </>,
    <>
        Click <strong>Settings</strong> in the side menu.
    </>,
    <>
        Under Settings, click <strong>WayaQuick Settings</strong>.
    </>,
    <>
        You'll see three tabs: Settlement Account, Payment Preferences and API Keys. Click{' '}
        <strong>API Keys</strong>.
    </>,
    <>
        Click <strong>Generate new secret key</strong>.
    </>,
    <>
        Click <strong>Copy</strong>, then paste the key into your server's environment variables or secret
        manager.
    </>,
];

export const KEY_MODES = {
    columns: ['Mode', 'Key starts with', 'What it does'],
    rows: [
        ['Test', <code>WAYASECK_TEST_</code>, 'Simulated payments. No real money moves.'],
        ['Live', <code>WAYASECK_PROD_</code>, 'Real payments. Available once your KYC has been approved.'],
    ],
};
